<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-snackbar
      v-model="snackbar"
      :color="color"
      right
      top
    >
      {{snackbarText}}
      <v-btn
        text
        dark
        @click="snackbar = false"
      >
        Fermer
      </v-btn>
    </v-snackbar>
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content">
            <v-card-title>
                <div class="text-left">
                    <span style="font-weight:700">Facture</span>
                    <v-menu
                      open-on-hover
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-5" @click="initExport" v-show="selectToExport == false" style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);" depressed small color="primary">Exporter</v-btn>
                        <v-btn v-bind="attrs"
                          v-on="on" style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);" depressed small color="primary">Nouveau</v-btn>
                      </template>

                      <v-list>
                        <v-list-item
                          v-for="(item, index) in [{title: 'Facture Standard'},{title: 'Facture D/A'},{title: 'Facture Magasinage'}, {title: 'Facture Surestarie'}]"
                          :key="index"
                        >
                          <v-list-item-title @click="newFacture(item.title)" style="cursor:pointer;">{{ item.title }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-text-field
                        style="width:470px"
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Rechercher.."
                        single-line
                        hide-details
                    ></v-text-field>
                </div>
              <v-spacer></v-spacer>
              <v-card width="500" class="ma-5 elevation-0 rounded-lg" style="border:1px solid rgba(0,0,0,0.2); font-family: 'Raleway', sans-serif; font-weight:700">
                  <v-card-title style="font-weight:700">
                    Statistiques
                    <v-spacer></v-spacer>
                    <v-btn small depressed dark>Voir Tous</v-btn>
                  </v-card-title>
                  <v-card-text class="text-left">
                      <p>Montant total facturé :<span style="float: right;"><b style="font-size: 22px; font-family: 'montserrat', sans-serif;">{{this.totalFacture.toFixed(3)}} </b>TND</span> </p>
                      <p>Montant factures non soldées :<span style="float: right;"><b style="font-size: 22px; font-family: 'montserrat', sans-serif;">{{this.totalNSolde.toFixed(3)}} </b>TND</span></p>
                      <p>Montant factures soldées : <span style="float: right;"><b style="font-size: 22px; font-family: 'montserrat', sans-serif;">{{this.totalSolde.toFixed(3)}} </b>TND</span></p>
                  </v-card-text>
              </v-card>
            </v-card-title>
            <v-card-text class="pa-0">
              <div v-if="selectToExport">
                <p>Veuillez selectionner les factures à exporter.</p>
                <v-layout class="px-7">
                  
                  <v-btn text color="primary" dense @click="selectedF = factureList">Sélectionner Tout</v-btn>
                  <v-btn text @click="selectedF = []">Déselectionner Tout</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn class="rounded-4" color="primary" outlined @click="exportExcel"><b>Exporter</b></v-btn>
                </v-layout>
              </div>
                <v-data-table
                    :headers="headers"
                    :items="factureList"
                    :loading="loader"
                    @click:row="openFacture"
                    :search="search"
                    :header-props="{ sortIcon: null }"
                    sort-by="num_facture"
                    sort-desc
                    v-model="selectedF"
                    :show-select="selectToExport == true"
                >
                  <template v-slot:[`item.num_facture`]="{ item }">
                    <div style="width:120px; text-align:center;">
                      <span>{{ item.num_facture }}</span>
                      <v-chip
                        color="primary"
                        v-if="item.is_magasinage"
                        dense
                        outlined
                      >
                        Magasinage
                      </v-chip>
                      <v-chip
                        color="primary"
                        v-else-if="item.is_da"
                        dense
                        outlined
                      >
                        Final D/A
                      </v-chip>
                      <v-chip
                        color="primary"
                        outlined
                        v-else-if="item.is_surestarie"
                        dense
                      >
                        Surestarie
                      </v-chip>
                      <v-chip
                        color="primary"
                        v-else
                        outlined
                        dense
                      >
                        Timbrage
                      </v-chip>
                      
                    </div>
                  </template>
                  <template v-slot:[`item.montantTotal`]="{ item }">
                    <div style="width:100px;">
                      <span>{{ item.montantTotal.toFixed(3) }} TND</span>
                    </div>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    <div style="width:100px;"><span>{{ item.date | formatDate }}</span></div>
                  </template>
                  <template v-slot:[`item.client`]="{ item }">
                    <div style="width:125px;">
                      <span>{{item.client_name}} <br/> Ref.{{item.code_client}}</span>
                    </div>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <div style="width:40px;">
                      <span v-if="item.status == true">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on" small color="primary">mdi-checkbox-marked-circle</v-icon>
                          </template>
                          <span>Soldé</span>
                        </v-tooltip>
                        </span>
                      <span v-else>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on" small color="red">mdi-cancel</v-icon>
                          </template>
                          <span>Non soldé</span>
                        </v-tooltip>
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`item.dossier`]="{ item }">
                    <div style="width:155px;">
                      <span v-if='item.num_dossier'>Dossier N°<v-btn :ripple="false" color="primary" small style="font-weight:700; color: rgb(0 196 255) !important; margin-left: 5px;" :to="{ name: 'singleFolder', params: { id: item.dossier_id }}" text>{{ item.num_dossier }}</v-btn></span>
                      <br />
                      <span v-if='item.num_avis'>Avis N°{{ item.num_avis }}</span>
                    </div>
                  </template>
                  <template v-slot:[`item.reglement`]="{ item }">
                    <div v-if="item.reglement.length > 0" width="150px">
                      <!--{{item.reglement[0].mode}} <span v-if="item.reglement[0].num_piece !== '' && item.reglement[0].banque !== ''">N°{{item.reglement[0].num_piece}} - {{item.reglement[0].banque}}</span> {{item.reglement[0].montant.toFixed(3)}} TND-->
                      {{item.reglement[0].mode}} - {{item.reglement[0].montant.toFixed(3)}} TND
                    </div>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <div style="width:105px;">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs" v-on="on"
                            small
                            class="mr-2"
                            :disabled="!permissions.includes('browse_facture')"
                            @click="openFacture(item)"
                          >
                            mdi-eye
                          </v-icon>
                        </template>
                        <span>Ouvrir</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs" v-on="on"
                            small
                            :disabled="!permissions.includes('edit_facture') || (item.reglement.length > 0) || (item.avis_id > 0 && item.is_magasinage === 0 && item. is_da === 0 && item.is_surestarie === 0) "
                            class="mr-2"
                            @click.stop="editFacture(item, item.type)"
                          >
                              mdi-pencil
                          </v-icon>
                        </template>
                        <span>Editer</span>
                      </v-tooltip>
                      <v-tooltip v-if="item.loader === false" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs" v-on="on"
                            small
                            class="mr-2"
                            @click.stop="printFacture(item)"
                          >
                              mdi-printer
                          </v-icon>
                          
                          
                          </template>
                        <span>Imprimer</span>
                      </v-tooltip>
                      <v-progress-circular
                        :width="2"
                        color="primary"
                        :size="20"
                        v-if="item.loader === true"
                        indeterminate
                      ></v-progress-circular>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs" v-on="on"
                            @click.stop="deleteFacture(item)"
                            :disabled="!permissions.includes('delete_facture')"
                            small
                          >
                            mdi-delete
                          </v-icon>
                          </template>
                        <span>Supprimer</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
            </v-card-text>
          </v-card>
          <!--
          <v-dialog v-model="newFactureDialog" v-if="newFactureDialog">
            <new-facture :currentAvis="null" :currentDossier="null" :type="newFactureType" v-on:reloadData="reloadData" v-on:closeNewFactureDialog="closeNewFactureDialogMethod" @hide="newFactureDialog = false"></new-facture>
          </v-dialog>
          <v-dialog v-model="editFactureDialog" v-if="editFactureDialog">
            <edit-facture :factureContent="factureContent" :dossierId="dossierId" v-on:reloadData="reloadData" v-on:closeEditFactureDialog="closeEditFactureDialogMethod" @hide="editFactureDialog = false"></edit-facture>
          </v-dialog>
          <v-dialog v-model="singleFactureDialog" v-if="singleFactureDialog">
            <single-facture :factureContent="factureContent" v-on:reloadData="reloadData" v-on:closeSingleFactureDialog="closeSingleFactureDialogMethod" @hide="singleFactureDialog = false"></single-facture>
          </v-dialog>
          <v-dialog v-model="printDialog" fullscreen v-if="printDialog">
            <print-facture :currentFacture="factureContent" v-on:closePrintDialog="closePrintDialogMethod" @hide="printDialog = false"></print-facture>
          </v-dialog>
          <v-dialog v-model="magasinageDialog" v-if="magasinageDialog">
            <new-facture-magasinage :currentAvis="null" :currentDossier="null" v-on:reloadData="reloadData" v-on:closeFactureMagasinageDialog="closeMagasinageDialogMethod" @hide="magasinageDialog = false"></new-facture-magasinage>
          </v-dialog>
          <v-dialog v-model="singleMagasinage" v-if="singleMagasinage">
            <single-facture-magasinage :currentAvis="null" :factureContent="factureContent" v-on:reloadData="reloadData" v-on:closeSingleFactureDialogMethod="closeSingleFactureDialogMethod" @hide="singleMagasinage = false"></single-facture-magasinage>
          </v-dialog>-->
          <v-dialog v-model="singleStandard" v-if="singleStandard">
            <single-standard-facture :factureContent="factureContent" v-on:reloadData="reloadData" @hide="singleStandard = false" v-on:hideDialog="singleStandard = false"></single-standard-facture>
          </v-dialog>
          <v-dialog v-model="createStandard" v-if="createStandard">
            <new-standard-facture  :currentAvis="null" :currentDossier="null" :type="newFactureType" v-on:reloadData="reloadData" @hide="createStandard = false" v-on:hideDialog="createStandard = false"></new-standard-facture>
          </v-dialog>
          <v-dialog v-model="editStandard" v-if="editStandard">
            <edit-standard-facture :factureContent="factureContent" :dossierId="dossierId" v-on:reloadData="reloadData" @hide="editStandard = false" v-on:hideDialog="editStandard = false"></edit-standard-facture>
          </v-dialog>
          <v-dialog v-model="printStandard" fullscreen v-if="printStandard">
            <print-standard-facture :currentFacture="factureContent" v-on:hideDialog="printStandard = false" @hide="printStandard = false"></print-standard-facture>
          </v-dialog>

          <v-dialog v-model="singleMagasinage" v-if="singleMagasinage">
            <single-facture-magasinage :factureContent="factureContent" v-on:reloadData="reloadData" v-on:hideDialog="singleMagasinage = false" @hide="singleMagasinage = false"></single-facture-magasinage>
          </v-dialog>
          <v-dialog v-model="createMagasinage" v-if="createMagasinage">
            <new-facture-magasinage :currentAvis="null" :currentDossier="null" v-on:reloadData="reloadData" v-on:hideDialog="magasinageDialog = false" @hide="magasinageDialog = false"></new-facture-magasinage>
          </v-dialog>
          <v-dialog v-model="editMagasinage" v-if="editMagasinage">
            <edit-magasinage-facture :factureContent="factureContent" :dossierId="dossierId" v-on:reloadData="reloadData" @hide="editMagasinage = false" v-on:hideDialog="editMagasinage = false"></edit-magasinage-facture>
          </v-dialog>
          <v-dialog v-model="printMagasinage" fullscreen v-if="printMagasinage">
            <print-magasinage-facture :currentFacture="factureContent" v-on:hideDialog="printMagasinage = false" @hide="printMagasinage = false"></print-magasinage-facture>
          </v-dialog>


          <v-dialog v-model="createDa" v-if="createDa">
            <new-da-facture :currentAvis="null" :currentDossier="null" v-on:reloadData="reloadData" v-on:hideDialog="createDa = false" @hide="createDa = false"></new-da-facture>
          </v-dialog>
          <v-dialog v-model="printDa" fullscreen v-if="printDa">
            <print-da-facture :currentFacture="factureContent" v-on:hideDialog="printDa = false" @hide="printDa = false"></print-da-facture>
          </v-dialog>
          <v-dialog v-model="editDa" v-if="editDa">
            <edit-da-facture :factureContent="factureContent" :dossierId="dossierId" v-on:reloadData="reloadData" @hide="editDa = false" v-on:hideDialog="editDa = false"></edit-da-facture>
          </v-dialog>
          <v-dialog v-model="singleDa" v-if="singleDa">
            <single-facture-da :factureContent="factureContent" v-on:reloadData="reloadData" v-on:hideDialog="singleDa = false" @hide="singleDa = false"></single-facture-da>
          </v-dialog>

          <v-dialog v-model="createSurestarie" v-if="createSurestarie">
            <new-facture-surestarie :currentAvis="null" :currentDossier="null" v-on:reloadData="reloadData"  v-on:hideDialog="createSurestarie = false" @hide="createSurestarie = false"></new-facture-surestarie>
          </v-dialog>
          <v-dialog v-model="editSurestarie" v-if="editSurestarie">
            <edit-facture-surestarie :factureContent="factureContent" v-on:reloadData="reloadData"  v-on:hideDialog="editSurestarie = false" @hide="editSurestarie = false"></edit-facture-surestarie>
          </v-dialog>
          <v-dialog v-model="singleSurestarie" v-if="singleSurestarie">
            <single-facture-surestarie :factureContent="factureContent" v-on:reloadData="reloadData" v-on:hideDialog="singleSurestarie = false" @hide="singleSurestarie = false"></single-facture-surestarie>
          </v-dialog>
          <v-dialog v-model="printSurestarie" fullscreen v-if="printSurestarie">
            <print-surestarie-facture :currentFacture="factureContent" v-on:hideDialog="printSurestarie = false" @hide="printSurestarie = false"></print-surestarie-facture>
          </v-dialog>

        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from '../commons/header_sidebar.component'

import newFactureMagasinage from '../dossier/facture/magasinage/new.component'
import singleFactureMagasinage from '../dossier/facture/magasinage/single.component'
import editMagasinageFacture from '../dossier/facture/magasinage/edit.component'
import printMagasinageFacture from '../dossier/facture/magasinage/print.component'

import singleStandardFacture from '../dossier/facture/standard/single.component'
import newStandardFacture from '../dossier/facture/standard/new.component'
import editStandardFacture from '../dossier/facture/standard/edit.component'
import printStandardFacture from '../dossier/facture/standard/print.component'

import newFactureSurestarie from '../dossier/facture/surestarie/new.component'
import editFactureSurestarie from '../dossier/facture/surestarie/edit.component'
import singleFactureSurestarie from '../dossier/facture/surestarie/single.component'
import printSurestarieFacture from '../dossier/facture/surestarie/print.component'

import singleFactureDa from '../dossier/facture/da/single.component'
import newDaFacture from '../dossier/facture/da/new.component'
import editDaFacture from '../dossier/facture/da/edit.component'
import printDaFacture from '../dossier/facture/da/print.component'

import XLSX from 'xlsx'

export default {
  name: 'facture-listing',
  components: {headerSidebar, printDaFacture, singleFactureMagasinage, singleStandardFacture, newStandardFacture, newFactureMagasinage, newDaFacture, singleFactureDa, editStandardFacture, editMagasinageFacture, printStandardFacture, printMagasinageFacture, newFactureSurestarie, singleFactureSurestarie, printSurestarieFacture, editFactureSurestarie, editDaFacture},
  data: () => ({
    singleStandard: false,
    singleMagasinage: false,
    singleSurestarie: false,
    singleDa: false,
    createStandard : false,
    createDa: false,
    createMagasinage: false,
    createSurestarie: false,
    editStandard: false,
    editDa: false,
    editMagasinage: false,
    editSurestarie: false,
    printStandard: false,
    printMagasinage: false,
    printDa: false,
    printSurestarie: false,
    drawer: true,
    mini: false,
    search: '',
    expanded: [],
    drawerClass: '',
    newFactureDialog: false,
    dialog: false,
    selectToExport: false,
    headers: [
        {text: 'N° Facture', value: 'num_facture'},
        {text: 'Libellé', value: 'libelle', align: ' d-none d-lg-table-cell'},
        {text: 'Date Création', value: 'date'},
        {text: 'Dossier/Avis', value: 'dossier', align: ' d-none d-lg-table-cell'},
        {text: 'Client', value: 'client'},
        {text: 'Montant Total', value: 'montantTotal'},
        {text: 'Dernier Règlement', value: 'reglement', align: ' d-none d-lg-table-cell'},
        {text: 'Etat', value: 'status'},
        {text: 'Actions', value: 'actions'}
    ],
    factureList: [],
    newFactureType : 'Facture Standard',
    loader: true,
    factureContent: {},
    singleFactureDialog: false,
    editFactureDialog: false,
    snackbar: false,
    snackbarText: '',
    color: "success",
    avisId: 0,
    dossierId: 0,
    totalFacture:0,
    totalNSolde:0,
    totalSolde:0,
    magasinageDialog : false,
    selectedF: []
  }),
  props: ['permissions'],
  mounted() {
      this.reloadData()

  },
  watch: {
    factureList: {
      deep: true,
      handler: 'calc_status'
    }
  },
  methods: {
    openFacture(facture){
        this.factureContent = facture 
        if(facture.is_magasinage === 1){
          this.singleMagasinage = true
        }else if(facture.is_da === 1){
          //this.singleStand = true
          this.singleDa = true
        }else if(facture.is_surestarie === 1){
          this.singleSurestarie = true
        }else{
          this.singleStandard = true
        }
    },
    initExport(){
      this.selectToExport = true
    },
    exportExcel() {
      //this.selectedF = this.factureList
      
      
      let d = this.selectedF
      d.sort(function(a,b){
        return new Date(b.date) - new Date(a.date);
      });

      
      let totalttc = 0
      let totaltht = 0
      let totalttva = 0
      let totaltimbre = 0
      let totalfret = 0
      let res = []
      let ca = {
        ht: 0,
        tva: 0,
        fret: 0,
        timbre:0,
        total: 0
      }
      let currentM = new Date(d[0].date).getMonth()
      d.forEach((item, key) => {
          let totalht = 0
          let totaltva = 0
          let totalfreight = 0
          item.fret = 0
          item.tva = 0
          item.totalHT = 0
          item.timbre = Number(item.timbre).toFixed(3)
          if(item.prestations.length > 0){
            item.prestations.forEach((prest, key) => {
              if(prest.cour > 0){
                  prest.montant = prest.cour * prest.montantDevise
              }
              if(prest.type_prestation == 'Fret'){
                totalfreight += prest.montant
              }
              totalht = totalht + prest.montant
              totaltva = prest.montant * prest.tva / 100  + totaltva
              prest.montantTva = Number(prest.montant.toFixed(3)) * prest.tva / 100
            })
            item.totalHT = totalht.toFixed(3)
            item.tva = totaltva.toFixed(3)
            
            if(totalfreight > 0){
              item.fret = totalfreight.toFixed(3)
            }

          }else{
            item.timbre = 0.000.toFixed(3)
          }
          item.fret = Number(item.fret).toFixed(3)
          item.tva = Number(item.tva).toFixed(3)
          item.totalHT = Number(item.totalHT).toFixed(3)
           let obj = {
              'Type Facture': item.type,
              'N°Facture': item.num_facture,
              'Client': item.client_name,
              'Code Client': item.code_client,
              'Date': this.$options.filters.formatDate(item.date),
              'Fret': item.fret.replace('.',','),
              'Total HT': item.totalHT.replace('.',','),
              'Total TVA': item.tva.replace('.',','),
              'Timbre': item.timbre.replace('.',','),
              'Total TTC': item.montantTotal.toFixed(3).replace('.',',')

            }
            
          if(new Date(item.date).getMonth() !== currentM){
            ca.fret += Number(totalfret.toFixed(3))
            ca.ht += Number(totaltht.toFixed(3))
            ca.tva += Number(totalttva.toFixed(3))
            ca.timbre += Number(totaltimbre.toFixed(3))
            ca.total += Number(totalttc.toFixed(3))
            res.push({'Date': 'Total TVA', /* 'Fret': totalfret.toFixed(3), 'Total HT': totaltht.toFixed(3), */ 'Total TVA': totalttva.toFixed(3).replace('.',','),  'Timbre': totaltimbre.toFixed(3).replace('.',',') /*,'Total TTC': totalttc.toFixed(3) */})
            totalttc = 0
            totaltht = 0
            totalttva = 0
            totaltimbre = 0
            totalfret = 0

            currentM = new Date(item.date).getMonth()
          }
          totaltht += Number(item.totalHT)
          totaltimbre += Number(item.timbre)
          totalttva += Number(item.tva)
          totalttc += Number(item.montantTotal)
          totalfret += Number(item.fret)
          res.push(obj)
          if(key+1 == d.length ){
            ca.fret += Number(totalfret.toFixed(3))
            ca.ht += Number(totaltht.toFixed(3))
            ca.tva += Number(totalttva.toFixed(3))
            ca.timbre += Number(totaltimbre.toFixed(3))
            ca.total += Number(totalttc.toFixed(3))
            res.push({'Date': 'Total TVA', /* 'Fret': totalfret.toFixed(3), 'Total HT': totaltht.toFixed(3), */ 'Total TVA': totalttva.toFixed(3).replace('.',','),  'Timbre': totaltimbre.toFixed(3).replace('.',',') /*,'Total TTC': totalttc.toFixed(3) */})
            totalttc = 0
            totaltht = 0
            totalttva = 0
            totaltimbre = 0
            totalfret = 0


            res.push({})
            res.push({'Date': 'CA', 'Fret': ca.fret.toFixed(3), 'Total HT': ca.ht.toFixed(3), 'Total TVA': ca.ht.toFixed(3),  'Timbre': ca.timbre.toFixed(3),'Total TTC': ca.total.toFixed(3)})
          }
       
      })

      /*res.push({'Date': 'Total', 'Fret': totalfret.toFixed(3), 'Total HT': totaltht.toFixed(3),  'Total TVA': totalttva.toFixed(3),  'Timbre': totaltimbre.toFixed(3), 'Total TTC': totalttc.toFixed(3)})
      totalttc, totaltht, totalttva, totalttc, totalfret = 0*/
      const data = XLSX.utils.json_to_sheet(res)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data, 'data')
      XLSX.writeFile(wb,'LISTE FACTURES.xlsx')
      this.selectToExport = false
    },
    async printFacture(facture){
      var index = this.factureList.indexOf(facture)
      this.factureList[index].loader = true
      await this.axios
          .get('/facture/single/'+facture.id)
          .then(response => {
            if(response.data.client_id > 0){
              this.axios
                  .get('/client/single/'+response.data.client_id)
                  .then(res => {
                    response.data.client = res.data
                    
                  })
            }
            this.factureContent = response.data
          }) 
      var self = this
      setTimeout(function(){
        self.factureList[index].loader = false
        if(facture.is_magasinage === 1){
          self.printMagasinage = true
        }else if(facture.is_da === 1){
          self.printDa = true
        }else if(facture.is_surestarie === 1){
          self.printSurestarie = true
        }else{
          self.printStandard = true
        }
      },500)
      
    },
    closeMagasinageDialogMethod(){
      this.magasinageDialog = false
    },
    newMagasinageFacture(){
      this.magasinageDialog = true
    },
    singleMagasinageFacture(facture){
      this.factureContent = facture 
      this.singleMagasinage = true
    },
    deleteFacture(item){
      const index = this.factureList.indexOf(item)
      if(item.reglement.length > 0){
        this.color = "error"
        this.snackbarText = "Impossible de supprimer une facture tant qu'elle contient un règlement."
        this.snackbar = true
      }else{
        if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?')){
          this.axios
            .delete('/facture/delete/'+item.id)
            .then(response => {
              if(response === 'error'){
                this.color = "error"
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                this.snackbar = true
              }else{
                this.factureList.splice(index, 1)
                this.color = "success"
                this.snackbarText = "La facture a été supprimée avec succès."
                this.snackbar = true
              }
            })
        }
      }
    },
    closePrintDialogMethod(){
      this.printStandard = false
    },
    closeEditFactureDialogMethod(){
      this.editFactureDialog = false
    },
    closeNewFactureDialogMethod(){
      this.newFactureDialog = false
      this.reloadData()
    },
    closeSingleFactureDialogMethod(){
      this.singleFactureDialog = false
    },
    newFacture(facture_type){
      this.newFactureType = facture_type
      if(this.newFactureType === 'Facture Magasinage'){
        this.createMagasinage = true
      }else if(this.newFactureType === 'Facture D/A'){
        this.createDa = true
      }else if(this.newFactureType === 'Facture Standard'){
        this.createStandard = true 
      }else if(this.newFactureType === 'Facture Surestarie'){
        this.createSurestarie = true
      }
      
    },
    editFacture(facture, type){
      this.factureContent = facture
      this.dossierId = facture.dossier_id
      if(type === 'Facture Magasinage'){
        this.editMagasinage = true
      }else if(type === 'Facture D/A'){
        this.editDa = true
      }else if(type === 'Facture Standard'){
        this.editStandard = true 
      }else if(type === 'Facture Surestarie'){
        this.editSurestarie = true 
      }
    },
    sortFacture(factList){
      return factList.sort((a,b) => (a.num_facture > b.num_facture) ? 1 : ((b.num_facture > a.num_facture) ? -1 : 0)); 
    },
    async reloadData(){
      await this.axios
        .get('/facture/listing')
        .then(response => {
              response.data = this.sortFacture(response.data)
              response.data.forEach((item, index) => {
                if(item.is_da === 1){
                  response.data[index].type = 'Facture D/A'
                }else if(item.is_magasinage === 1){
                  response.data[index].type = 'Facture Magasinage'
                }else if(item.is_surestarie === 1){
                  response.data[index].type = 'Facture Surestarie'
                }else {
                  response.data[index].type = 'Facture Standard'
                }
                var facture_id = item.id
                var avis_id = item.avis_id
                response.data[index].montantTotal = 0
                response.data[index].loader = false
                if(avis_id !== 0){
                  if(item.is_magasinage === 1 || item.is_surestarie === 1 || item.is_da === 1){
                    this.axios.get('/facture/single/'+facture_id)
                    .then(resFact => {
                      let totalnt = 0
                      let totalt = 0
                      let totaltva = 0
                      let total = 0
                      resFact.data.prestations.forEach((prest,ind) => {
                        
                        prest.cour = Number(prest.cour)
                        prest.montant = Number(prest.montant)
                        prest.montantDevise = Number(prest.montantDevise)
                        prest.tva = Number(prest.tva)
                        if(prest.cour > 0){
                            prest.montant = prest.cour * prest.montantDevise
                        } 
                        if(prest.tva === 0){
                            totalnt = prest.montant + totalnt
                        }else{
                            totaltva = prest.montant * prest.tva / 100  + totaltva
                            totalt = prest.montant + totalt
                        }
                        
                        
                        prest.montantTva = Number(prest.montant.toFixed(3)) * prest.tva / 100
                        //response.data[index].montantTotal = Number(Number(response.data[index].montantTotal).toFixed(3)) + Number(Number(prest.montant).toFixed(3)) + Number(Number(prest.montant * prest.tva / 100))
                      })
                      
                      total =  Number(total.toFixed(3)) + Number(totalnt.toFixed(3)) + Number(totalt.toFixed(3)) + Number(totaltva.toFixed(3)) + Number(resFact.data.timbre.toFixed(3))
                      response.data[index].montantTotal = total
                      response.data[index].prestations = resFact.data.prestations
                    })
                  }else{
                    this.axios.get('/avis/single/'+avis_id)
                    .then(resAvis => {
                      let totalnt = 0
                    let totalt = 0
                    let totaltva = 0
                    let total = 0
                    resAvis.data.prestations.forEach((prest,ind) => {
                      
                      prest.cour = Number(prest.cour)
                      prest.montant = Number(prest.montant)
                      prest.montantDevise = Number(prest.montantDevise)
                      prest.tva = Number(prest.tva)
                     if(prest.cour > 0){
                          prest.montant = prest.cour * prest.montantDevise
                      } 
                      if(prest.tva === 0){
                          totalnt = prest.montant + totalnt
                      }else{
                          totaltva = prest.montant * prest.tva / 100  + totaltva
                          totalt = prest.montant + totalt
                      }
                      
                      
                      prest.montantTva = Number(prest.montant.toFixed(3)) * prest.tva / 100
                      //response.data[index].montantTotal = Number(Number(response.data[index].montantTotal).toFixed(3)) + Number(Number(prest.montant).toFixed(3)) + Number(Number(prest.montant * prest.tva / 100))
                    })
                    
                    total =  Number(total.toFixed(3)) + Number(totalnt.toFixed(3)) + Number(totalt.toFixed(3)) + Number(totaltva.toFixed(3)) + Number(response.data[index].timbre.toFixed(3))
                    response.data[index].montantTotal = total
                    response.data[index].prestations = resAvis.data.prestations

                    
                    })
                  }
                  
                }else{
                  this.axios.get('/facture/single/'+facture_id)
                  .then(resFact => {
                    let totalnt = 0
                    let totalt = 0
                    let totaltva = 0
                    let total = 0
                    resFact.data.prestations.forEach((prest,ind) => {
                      
                      prest.cour = Number(prest.cour)
                      prest.montant = Number(prest.montant)
                      prest.montantDevise = Number(prest.montantDevise)
                      prest.tva = Number(prest.tva)
                     if(prest.cour > 0){
                          prest.montant = prest.cour * prest.montantDevise
                      } 
                      if(prest.tva === 0){
                          totalnt = prest.montant + totalnt
                      }else{
                          totaltva = prest.montant * prest.tva / 100  + totaltva
                          totalt = prest.montant + totalt
                      }
                      
                      
                      prest.montantTva = Number(prest.montant.toFixed(3)) * prest.tva / 100
                      //response.data[index].montantTotal = Number(Number(response.data[index].montantTotal).toFixed(3)) + Number(Number(prest.montant).toFixed(3)) + Number(Number(prest.montant * prest.tva / 100))
                    })
                    
                    total =  Number(total.toFixed(3)) + Number(totalnt.toFixed(3)) + Number(totalt.toFixed(3)) + Number(totaltva.toFixed(3)) + Number(resFact.data.timbre.toFixed(3))
                    response.data[index].montantTotal = total
                    response.data[index].prestations = resFact.data.prestations
                  })
                }                
              })
              this.factureList = this.sortFacture(response.data)         
              this.calculFacture()     
            })
        .catch(error => {
            console.log(error)
        })
    },
    calculFacture(){
      
      this.factureList.forEach((facture, key) => {
        this.totalFacture = this.totalFacture + Number(Number(facture.montantTotal).toFixed(3))
      })
    },
    calc_status(fact_list){
      fact_list.forEach((item, index) => {
        let totalReglement = 0

        item.reglement.forEach((reglement, key) => {
          totalReglement = totalReglement + Number(reglement.montant.toFixed(3))
        })
        if( Number(item.montantTotal) == Number(item.timbre) ){
          item.montantTotal = 0
        }
        if(Number(totalReglement.toFixed(3)) === Number(item.montantTotal.toFixed(3))){
          item.status = true
        }else{
          item.status = false
        }
        fact_list[index] = item
      })
      this.totalFacture = 0
      this.totalNSolde = 0
      this.totalSolde = 0
      fact_list.forEach((facture, key) => {
        facture.reglement.forEach((reglement, index) => {
          this.totalSolde = this.totalSolde + Number(reglement.montant.toFixed(3))
        })
        this.totalFacture = this.totalFacture + Number(facture.montantTotal.toFixed(3))
        this.totalNSolde = Number( this.totalFacture - this.totalSolde)
        
      })
      this.factureList = fact_list
      this.loader = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .v-data-table >>> .v-data-table-header > tr {
    background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
    th, td {
      color: white !important;
      .v-icon{
        color: white !important;
      }
    }
  }
  .v-data-table >>> .v-data-table__wrapper{
    padding:5px 25px;
  }
  .v-data-table >>> div > table {
    border-spacing: 0 20px;
    tr td:first-child { border-top-left-radius: 25px; border-bottom-left-radius: 25px; }
    tr th:first-child { border-top-left-radius: 25px; border-bottom-left-radius: 25px; }
    tr td:last-child { border-top-right-radius: 25px; border-bottom-right-radius: 25px; }
    tr th:last-child { border-top-right-radius: 25px; border-bottom-right-radius: 25px; }
    tr > th{
      border:0px solid !important;
    }
  }
  
  .v-data-table >>> table {
    .v-data-table__empty-wrapper {
      background: white !important;
      td{
        background: white !important;
        color: rgba(0,0,0,.87) !important;
        &:hover{
          background: white !important;
          color: rgba(0,0,0,.87) !important;
        }
      }
      &:hover{
        background: white !important;
        color: rgba(0,0,0,.87) !important;
      }
      
    }
    tr:not(.v-data-table__expanded) {
      background: white;
      opacity: 1;
      transition: all 0.3s ease-in;
      background-position:0 -85px;
      &:hover {
        th, td {
          color: white;
          .v-chip{
                color:rgb(0, 196, 255) !important;
                caret-color: white !important;
              }
          .v-icon{
            color: white;
            &--disabled {
              color:rgba(255,255,255,0.3) !important;
            }
          }
        }
        background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
        opacity: .9;
        background-position:0px !important;  
        background-repeat: no-repeat !important;

        th , th.sortable {
          color: white;
          .v-icon{
            color: rgba(255,255,255,0.8);
          }
        }
      }
      
    }
    .v-data-table__expanded__row, .v-data-table__expanded__row:hover{
      
        box-shadow: 0 10px 20px rgba(0,0,0,0.2);
        border-radius: 25px;
        background: linear-gradient(90deg, #0d4aba 0%, #099bdf 100%) !important;
            td {
              color:white;
              .v-icon{
                color:white;
              }
              
              .v-chip{
                color:white !important;
                caret-color: white !important;
              }
            }
    }
  }
  .v-data-table >>> tr:not(.v-data-table__expanded) {
    box-shadow: 10px 10px 20px rgba(0,0,0,0.1);
    border-radius:25px;
  }
  .v-data-table >>> td {
    height: 85px;
    border-bottom: 0px solid !important;
    padding: 0px;
  }
 .v-data-table >>> .text-start{
    height:85px !important
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table th{
    min-height: 325px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/facture/listing.vue